import { Skeleton } from 'antd';
import * as Styled from './styles';
import { NftDetailsPlainSkeleton } from './views/NftDetailsPlain/Skeleton';

export const NftPropertiesHistorySkeleton = () => {
  return (
    <Styled.Wrapper>
      <Skeleton.Button
        active
        block
        style={{
          height: 52,
          width: '100%',
          borderRadius: 12,
          margin: '32px 0 40px 0'
        }}
      />
      <NftDetailsPlainSkeleton />
    </Styled.Wrapper>
  );
};
